import PropTypes from 'prop-types';

class DetectPlatform {
    constructor(userAgent) {
        this.userAgent = userAgent;
    }

    isAndroid() {
        return /Android/.test(this.userAgent);
    }

    isIPhone() {
        return /iPhone/.test(this.userAgent);
    }

    isIPad() {
        return /iPad/.test(this.userAgent);
    }

    isIPod() {
        return /iPod/.test(this.userAgent);
    }

    isAppleMobileDevice() {
        return this.isIPhone() || this.isIPad() || this.isIPod();
    }

    isDesktop() {
        return !this.isAndroid() && !this.isAppleMobileDevice();
    }
}

DetectPlatform.propTypes = {
    userAgent: PropTypes.node.isRequired,
};

export default DetectPlatform;
